import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PAYMENT_DOCUMENT } from "./apiRoutes";

interface UseGetPaymentStatProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPaymentStat = async (communityId: string) =>
  await axiosAuth.get(`${PAYMENT_DOCUMENT}/stats/${communityId}`);

const useGetPaymentStat = ({
  communityId,
  queryParams,
}: UseGetPaymentStatProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["payment-stat", communityId],
    queryFn: () => getPaymentStat(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetPaymentStat;
